export function randomString(length: number): string {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let str = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    str += characters.charAt(randomIndex);
  }
  return str;
}

// Gets the query params from the URL and URIdecodes them
// NOTE: this doesn't support keys with multiple values in the query params. For instance,
// if you have https://url.com?name=jack&age=20&age=30, the result would be
// { name: jack, age: 30 }, so the age=20 would be overwritten
export function getQueryParamsFromUrl(url: string): any {
  if (!url) url = window.location.href;
  if (!url.match(/\?/)) return {};

  // get the query params off the url
  const urlSplit = url.split("?");
  const queryParamsStr = urlSplit[1];
  const queryParamsArr = queryParamsStr.split("&");

  // for each query param, add the key/value pair to the queryParams object
  // and decode the value
  let queryParams: any = {};
  queryParamsArr.forEach((param) => {
    const paramArr = param.split("=");
    const key = paramArr[0];
    const value = paramArr[1];
    queryParams[key] = decodeURIComponent(value);
  });

  return queryParams;
}

// takes an object of query params and creates a URIencoded string (doesnt
// include '?' symbol at the start)
export function encodeQueryParamsForUrl(params: any): string {
  let result = "";
  for (let key in params) {
    if (result) result += "&";
    result += `${key}=${encodeURIComponent(params[key])}`;
  }
  return result;
}

export function supportChat(flagZendesk: any) {
  if (flagZendesk) {
    // @ts-expect-error
    zE("webWidget", "show");
    // @ts-expect-error
    zE("webWidget", "open");
  } else {
    const chatUrl = `https://v2.zopim.com/widget/livechat.html?key=2AekYJAlcSZCOOwpwwxkRyIkGeHIDfty&api_calls=[["concierge.setName",["Suralink Support"]],["concierge.setTitle",["Suralink Support"]],["theme.reload",[]],["theme.reload",[]]]&hostname=${window.location.href}&lang=en`;
    window.open(
      chatUrl,
      "_blank",
      "location=yes,height=570,width=440,scrollbar=yes,status=yes"
    );
  }
}
